import notificationApi from '../notification/notificationApi';
import type {
  DeleteNotificationRequest,
  UpdateReadStatusRequest,
  GetNotificationsRequest,
} from '../notification/notificationTypes';

const notificationApiService = {
  deleteNotification: (payload: DeleteNotificationRequest) =>
    notificationApi.deleteNotification(payload),

  deleteAllNotifications: () =>
    notificationApi.deleteAllNotifications(),

  updateReadStatus: (payload: UpdateReadStatusRequest) =>
    notificationApi.updateReadStatus(payload),

  getNotifications: (payload: GetNotificationsRequest) =>
    notificationApi.getNotifications(payload),

  getNotificationCount: () =>
    notificationApi.getNotificationCount(),
};

export default notificationApiService;
